// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__18SV0","label":"Category_label__sYjjs","content":"Category_content__C15sP","header":"Category_header__3yNXo","location":"Category_location__395xr"};